const schoolVakantiesUren = {
  "2019": { "1": 9, "2": 15, "3": 45, "4": 14 },
  "2020": { "1": 8, "2": 14, "3": 44, "4": 15 },
  "2021": { "1": 6, "2": 14, "3": 44, "4": 10 },
  "2022": { "1": 6, "2": 14, "3": 44, "4": 10 },
  "2023": { "1": 6, "2": 14, "3": 44, "4": 10 },
};

export default schoolVakantiesUren
